export enum ScheduleValidationErrorMessage {
  WINDOW_BEFORE_IS_NEGATIVE = 'Not Supported: windowBefore.value can not be negative',
  WINDOW_AFTER_IS_NEGATIVE = 'Not Supported: windowAfter.value can not be negative',
  TIME_OF_DAY_CONFLICT = 'Not Supported: can not use times of day together with period or frequency',
  INVALID_COMBINATION_OF_WINDOWS_WITHOUT_TIME_OF_DAY = 'Not supported: can not use days of week, no times of day and windowBefore/windowAfter with time unit smaller than Day',
  INVALID_COMBINATION_OF_INITIATION_AND_TIMING = 'Not supported: can not use repeating request in combination with HCP or RPM_EVENT initiator',
}
